var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sub-menu mb-xl"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"sub-menu__list"},[_vm._l((_vm.studentMenu),function(item,index){return _c('li',{key:index,staticClass:"sub-menu__list-item"},[_c('router-link',{staticClass:"sub-menu__list-item-link",attrs:{"to":{ name: item.link, params: { id: _vm.id } },"active-class":"active"}},[_vm._v("\n              "+_vm._s(item.title)+"\n            ")])],1)}),_vm._v(" "),_c('li',{staticClass:"sub-menu__list-item"},[(
                _vm.$perm(
                  'student.view_behavior_exit_permissions',
                  _vm.user.campus_id
                )
              )?_c('router-link',{class:[
                'sub-menu__list-item-link',
                _vm.$route.name === 'StudentBehavior' &&
                _vm.$route.query.tab === 'exit-permissions'
                  ? 'active'
                  : ''
              ],attrs:{"to":{
                name: 'StudentBehavior',
                params: { id: _vm.id },
                query: { tab: 'exit-permissions' }
              }}},[_vm._v("\n              אישורי יציאה\n            ")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"sub-menu__list-item"},[(_vm.$perm('student.view_behavior_attendance', _vm.user.campus_id))?_c('router-link',{class:[
                'sub-menu__list-item-link',
                _vm.$route.name === 'StudentBehavior' &&
                _vm.$route.query.tab === 'attendance'
                  ? 'active'
                  : ''
              ],attrs:{"to":{
                name: 'StudentBehavior',
                params: { id: _vm.id },
                query: { tab: 'attendance' }
              }}},[_vm._v("\n              נוכחות\n            ")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"sub-menu__list-item"},[_c('router-link',{class:[
                'sub-menu__list-item-link',
                _vm.$route.name === 'StudentBehavior' && !_vm.$route.query.tab
                  ? 'active'
                  : ''
              ],attrs:{"to":{ name: 'StudentBehavior', params: { id: _vm.id } }}},[_vm._v("\n              תיעוד\n            ")])],1)],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }